<template>
    <div class="tg-loadding">
        <div class="tg-loaddingInner">
        	Loading...
        </div>
    </div>
</template>
<style lang="scss">
.tg-loadding{
	overflow: hidden;
}
.tg-loadding .tg-loaddingInner {
  margin: 0 auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 4px solid rgba(255, 255, 255, 0.2);
  border-right: 4px solid rgba(255, 255, 255, 0.2);
  border-bottom: 4px solid rgba(255, 255, 255, 0.2);
  border-left: 4px solid #ff4c48;
  -webkit-animation: tgload 1.1s infinite linear;
  animation: tgload 1.1s infinite linear;
}
.tg-loadding .tg-loaddingInner,
.tg-loadding .tg-loaddingInner:after {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}
@-webkit-keyframes tgload {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes tgload {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
<script>
export default {
	
}
</script>